<template>
  <DragPanel
    title="批注"
    :closePanel="closePanel"
    :tooltipVisible="false">
    <div
      class="annotation-filter-box"
      v-if="originAnnotationList.length">
      <div class="label-box">批注类型：</div>
      <el-select
        class="primary-select"
        size="small"
        v-model="annotationTypeId"
        clearable
        :popper-append-to-body="false"
        @focus="initAnnotationTypeList()"
        @change="updateAnnotationList">
        <el-option
          v-for="(item, index) in annotationTypeList"
          :key="index"
          :label="item.typeName"
          :value="item.typeValue">
          <div
            class="text-overflow"
            :title="item.typeName">
            {{ item.typeName }}
          </div>
        </el-option>
      </el-select>
    </div>
    <AnnotationList
      :annotationList="filterAnnotationList"
      @openViewportImg="openViewportImg"
      @closeViewportImg="closeViewportImg"
      @openAnnotationViewport="openAnnotationViewport"
      @openAnnotationDetailsPanel="openAnnotationDetailsPanel" />
    <AnnotationDetailsPanel
      v-if="isAnnotationDetailsPanelVisible"
      :sceneInfo="sceneInfo"
      :annotationDetails="annotationDetails"
      @closeAnnotationDetailsPanel="closeAnnotationDetailsPanel" />
    <div
      class="viewport-img-box"
      v-if="isViewportImgVisible">
      <img
        :src="viewportImg"
        alt=""
        srcset="" />
    </div>
  </DragPanel>
</template>

<script>
import DragPanel from '@/components/CustomDragPanel.vue'
import AnnotationList from './AnnotationList.vue'
import AnnotationDetailsPanel from './AnnotationDetailsPanel.vue'

import {
  getSceneAnnotationListService,
  getAnnotationTypeListService
} from '@/service/share/sceneShareInterface.js'

export default {
  data() {
    return {
      originAnnotationList: [],
      filterAnnotationList: [],
      annotationTypeList: [],
      annotationTypeId: '',

      isViewportImgVisible: '',
      viewportImg: '',

      isAnnotationDetailsPanelVisible: false,
      annotationDetails: {}
    }
  },
  props: {
    sceneInfo: Object
  },
  components: {
    DragPanel,
    AnnotationList,
    AnnotationDetailsPanel
  },
  mounted() {
    this.initData()
  },
  methods: {
    async initData() {
      this.annotationTypeList = await this.queryAnnotationTypeList()
      this.queryAnnotationList().then(annotationList => {
        this.originAnnotationList = annotationList
        this.filterAnnotationList = annotationList
      })
    },
    async initAnnotationTypeList() {
      this.annotationTypeList = await this.queryAnnotationTypeList()
    },
    closePanel() {
      this.$emit('closeAnnotationPanel')
    },
    openAnnotationDetailsPanel(annotationDetails) {
      this.annotationDetails = annotationDetails
      this.isAnnotationDetailsPanelVisible = true
    },
    closeAnnotationDetailsPanel() {
      this.annotationDetails = {}
      this.isAnnotationDetailsPanelVisible = false
    },
    openViewportImg(viewportImg) {
      if (this.isAnnotationDetailsPanelVisible) return

      this.viewportImg = viewportImg
      this.isViewportImgVisible = true
    },
    closeViewportImg() {
      this.isViewportImgVisible = false
      this.viewportImg = ''
    },
    openAnnotationViewport(viewportImg) {
      this.$emit('openAnnotationViewport', viewportImg)
    },
    updateAnnotationList(value) {
      if (value) {
        let filterAnnotationList = this.originAnnotationList.filter(
          item => item.annotationTypeId === value
        )
        this.filterAnnotationList = filterAnnotationList
      } else {
        this.filterAnnotationList = this.originAnnotationList
      }
    },
    async queryAnnotationTypeList() {
      let projectZoneId = this.sceneInfo.projId
      let headers = this.getHeaders()
      // prettier-ignore
      let response = await getAnnotationTypeListService({ projectZoneId }, headers)
      if (response.isSuccess) {
        let data = response.data
        let annotationTypeList = data.map(item => {
          item.typeName = item.name
          item.typeValue = item.annotationTypeId
          return item
        })
        return annotationTypeList
      } else {
        this.$message.error(response.errMsg)
      }
    },
    queryAnnotationList() {
      return new Promise(resolve => {
        let sceneId = this.$route.params.resourceId
        let headers = this.getHeaders()
        getSceneAnnotationListService(sceneId, headers).then(response => {
          if (response.isSuccess) {
            let annotationList = response.data
            resolve(annotationList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    getHeaders() {
      let token = this.$route.query.token
      let headers = {
        Authorization: token
      }
      return headers
    }
  }
}
</script>

<style lang="less" scoped>
.common-drag-panel {
  top: 214px;
  right: 20px;
  width: 360px;
  height: calc(100% - 225px);

  :deep(.content) {
    display: flex;
    flex-direction: column;
    height: calc(100% - 40px);
    padding: 8px 20px 16px 16px;

    .annotation-filter-box {
      display: flex;
      align-items: center;
      margin-top: 8px;
      font-size: 14px;

      .label-box {
        flex-shrink: 0;
      }

      .primary-select {
        flex-grow: 1;

        .el-select-dropdown {
          width: 100%;
        }
      }
    }

    .viewport-img-box {
      position: absolute;
      left: -50%;
      transform: translate(-50%, 50%);
      margin-left: -30px;
      width: 400px;
      height: 225px;
      background-size: cover;
      background-position: center;
      z-index: 3;
      box-shadow: var(--base-bg-dark-color30);
      border-radius: 8px;
      border: 4px solid var(--base-border-dark-color21);
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        object-fit: cover;
      }
    }
  }
}
</style>
